export default {
  mandatory_step: "Mandatory",
}
